export enum HostOperationType {
  None = 1,
  Team = 2,
  Indivisual = 3,
}
